import MapClusterView from './MapClusterView';

export default MapClusterView;
